import React from "react"
import { Link } from "gatsby"
// import * as styles from "./TouchpointIcons.module.css"

import Content from "./Content/Content"
import Section from "./Section/Section"
import Text from "./Text/Text"
import Kiosk from "../../../images/touchpoint_/kiosk.inline.svg"
import QR from "../../../images/touchpoint_/QR.inline.svg"
import Email from "../../../images/touchpoint_/email.inline.svg"
import SMS from "../../../images/touchpoint_/SMS.inline.svg"
import WebsiteApp from "../../../images/touchpoint_/website-app.inline.svg"
import CallCenter from "../../../images/touchpoint_/call-center.inline.svg"
import Hover from "./Hover/Hover"

const icons = [
  {
    svg: Kiosk,
    text: "Kiosk",
    link: "/products/feedback-kiosk-smiley-terminal/",
  },
  { svg: QR, text: "QR", link: "/products/qr-code-and-tap-feedback/" },
  { svg: Email, text: "Email", link: "/products/email-feedback/" },
  { svg: SMS, text: "SMS", link: "/products/sms-feedback/" },
  {
    svg: WebsiteApp,
    text: "Website/App",
    link: "/products/website-digital-feedback/",
  },
  {
    svg: CallCenter,
    text: "Call Center",
    link: "/products/voice-call-center-feedback/",
  },
]

const TouchpointIcons = () => {
  return (
    <Content columns={6} gap={32} style={{ marginTop: 0 }}>
      {icons.map(({ svg: SVG, text, link }) => (
        <Hover key={text} type="scale">
          <Link to={link}>
            <Section style={{ padding: 0 }}>
              <SVG style={{ marginBottom: "10px" }} />
              <Text color="#689">{text}</Text>
            </Section>
          </Link>
        </Hover>
      ))}
    </Content>
  )
}

export default TouchpointIcons
